/* eslint-disable react/no-array-index-key */
import React from "react";
import styled from "styled-components";

import WeightsTableMBA from "../WeightsTableMBA";
import spinner from '../../../../../images/paul_loading.gif';

import { Container } from "./styles";

const Loading = styled.div`
  z-index: 99;
  top: 66px;
  width: 50%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  filter: blur(0px);
  background: white;
`;

function GeneralGraphicsMBA({ weights }) {
  if (!weights) return (
    <Loading>
      <img
        alt="loading"
        style={{
          maxHeight: '50%',
          animation: 'loading-spin infinite 10s linear'
        }}
        src={spinner}
      />
    </Loading>
  );
  return (
    <Container>
      <div className="row">
        <div className="col-12">
          <WeightsTableMBA data={weights} />
        </div>
      </div>
    </Container>
  );
}

export default GeneralGraphicsMBA;
